import { encodeFanCode, laneGapPxForRouteType } from "./fan-code.js";
export const isRouteShapePath = (row) => !!row && row.path instanceof Float64Array;
export const recordIsCleaned = (record) => (record.slots != null && record.slots.length > 0) ||
    (record.bandCounts != null && record.bandCounts.length > 0);
export const largestBundleIn = (rows) => {
    let largest = 0;
    for (const row of rows) {
        const summary = Number(row.band_count);
        if (summary > largest)
            largest = summary;
        const counts = row.bandCounts;
        if (counts)
            for (let i = 0; i < counts.length; i++)
                if (counts[i] > largest)
                    largest = counts[i];
    }
    return largest;
};
export function buildRouteShapePaths(records, options = {}) {
    const out = [];
    for (const rec of records) {
        const lons = rec?.lons;
        const lats = rec?.lats;
        if (!lons || !lats)
            continue;
        const n = Math.min(lons.length, lats.length);
        if (n < 2)
            continue;
        const cleaned = options.cleaned ?? recordIsCleaned(rec);
        const gap = options.getGapPx ? options.getGapPx(rec) : laneGapPxForRouteType(rec.route_type_name);
        const slots = cleaned && rec.slots && rec.slots.length === n ? rec.slots : null;
        const radii = rec.turnRadii && rec.turnRadii.length === n ? rec.turnRadii : null;
        const counts = cleaned && rec.bandCounts && rec.bandCounts.length === n ? rec.bandCounts : null;
        const path = new Float64Array(n * 2);
        const fanCodes = cleaned ? new Float32Array(n) : null;
        for (let i = 0; i < n; i++) {
            path[i * 2] = lons[i];
            path[i * 2 + 1] = lats[i];
            if (!fanCodes)
                continue;
            let slotPx = 0;
            if (slots) {
                const lo = i > 0 ? i - 1 : 0;
                const hi = i < n - 1 ? i + 1 : n - 1;
                let sum = 0;
                for (let k = lo; k <= hi; k++)
                    sum += slots[k];
                slotPx = (sum / (hi - lo + 1)) * gap;
            }
            const r = radii ? radii[i] : 5000;
            fanCodes[i] = encodeFanCode(Number.isFinite(slotPx) ? slotPx : 0, Number.isFinite(r) ? r : 5000, counts ? counts[i] : 1, gap);
        }
        const { lons: _lons, lats: _lats, slots: _s, turnRadii: _t, bandCounts: _b, ...rest } = rec;
        out.push({ ...rest, path, fanCodes });
    }
    return out;
}
//# sourceMappingURL=route-shape-paths.js.map